namespace Ir.Components.Workbook.Settings.Items.MetricFormatSetting {
    export interface IMetricFormatSettingComponent {
        reload: () => void;
    }
    export interface IMetricFormatSettingParams {
        value: KnockoutObservable<FieldFormatEnum>;
        onFiltering?: (items: Array<({ id: FieldFormatEnum, text: string })>) => Array<({ id: FieldFormatEnum, text: string })>;
        getComponent?: (component: IMetricFormatSettingComponent) => void;
    }
    interface IViewModel {
        selectBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        selectBoxComponent: DevExpress.ui.dxSelectBox;
        label: string;
    }

    interface IParams {
        config: IMetricFormatSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        this.label = "Format";
        this.selectBoxOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: params.config.value,
            items: getItems(params.config),
            width: 117,
            onInitialized(e) {
                self.selectBoxComponent = e.component;
            }
        };

        if (params.config.getComponent) {
            params.config.getComponent({
                reload() {
                    self.selectBoxComponent.option("dataSource", getItems(params.config));
                }
            } as IMetricFormatSettingComponent);
        }
    }

    function getItems(config: IMetricFormatSettingParams) {
        let items = [
            { id: FieldFormatEnum.None, text: 'Based on Metric' },
            { id: FieldFormatEnum.Currency, text: 'Currency' },
            { id: FieldFormatEnum.Numeric, text: 'Numeric' },
            { id: FieldFormatEnum.Percentage, text: 'Percentage' }
        ];

        if (config.onFiltering) {
            return config.onFiltering(items);
        }

        return items;
    }
}